"use client";
import React, { useEffect, useRef } from "react";
import style from "./Hero.module.scss";
import gsap from "gsap";
import CommonDuckScene from "../../common/3D/CommonDuckScene/CommonDuckScene";
export const Hero = ({ messages }) => {
  const heroRef = useRef(null);

  useEffect(() => {
    gsap.fromTo(
      [".titleFirst", ".titleSecond"],
      {
        x: gsap.utils.wrap(["-50%", "50%"]),
        opacity: 0,
      },
      {
        x: "0%",
        opacity: 1,
        duration: 1,
        ease: "power4.out",
      }
    );
    gsap.fromTo(
      ".paragraph",
      {
        opacity: 0,
      },
      {
        opacity: 1,
        duration: 2,
        ease: "power4.out",
      }
    );
  }, [heroRef]);

  return (
    <section className={style.heroWrap} ref={heroRef}>
      <div className={`${style.content} container`}>
        <div>
          <h1 className="title-section">
            <span className="titleFirst">{messages.first_words}</span>
            <span className="titleSecond">
              {messages.second_words}
              <span className={`${style.lastWord} title-outline`}>
                {" "}
                {messages.last_word}
              </span>
            </span>
          </h1>
          <p className="paragraph">{messages.description}</p>
        </div>
        <CommonDuckScene />
      </div>
    </section>
  );
};
